/**
* @prop --uic-header-menu-bg-color-hover: background color when hovered
* @prop --uic-header-menu-text-color: default text and icon color
* @prop --uic-header-menu-text-color-active: text and icon color when the item is active
* @prop --uic-header-menu-text-color-focus: text and icon color when the item has focus
* @prop --uic-header-menu-text-color-selected: text and icon color when the item is selected
* @prop --uic-header-menu-text-color-disabled: text and icon color when the item is disabled
* @prop --uic-header-menu-border-color: outline color
* @prop --uic-header-menu-border-color-focus: outline color when the item has focus
* @prop --uic-header-menu-border-style: outline style
* @prop --uic-header-menu-border-width: outline thickness
*/
uic-header-menu-item {
    flex: 0 0 auto;
    display: block;
    position: relative;
    height: var(--uic-header-height);
    font-size: var(--uic-font-size-normal);
    line-height: var(--uic-line-height-normal);
    font-weight: var(--uic-font-weight-bold);
    color: var(--uic-header-menu-text-color);
    outline: 2px solid transparent;
    outline-offset: -2px;
    user-select: none;

    .uic-header-menu--vertical &,
    .uic-header-menu-item__submenu & {
        flex: 1 0 auto;
    }

    @media #{$breakpoint_smartphone} {
        min-width: 48px;
    }

    .uic-header-menu-item__label {
        display: inline-block;
        flex: 1 0 auto;
    }

    .uic-header-menu-item__label + uic-icon {
        margin-left: 8px;
    }

    uic-icon ~ .uic-header-menu-item__label {
        margin-left: 8px;
    }

    uic-icon {
        flex: 0 0 auto;
    }

    uic-badge {
        position: absolute;
        left: 5px;
        top: 5px;
    }

    &:not([disabled]) {
        cursor: pointer;
    }

    &[disabled] {
        color: var(--uic-header-menu-text-color-disabled);
        pointer-events: none;
    }

    &[selected] > .uic-header-menu-item__item {
        color: var(--uic-header-menu-text-color-selected);
    }

    &:focus {
        outline-color: var(--uic-header-text-color-active);
    }

    &:focus > .uic-header-menu-item__item {
        color: var(--uic-header-menu-text-color-focus);
    }

    &:active > .uic-header-menu-item__item {
        color: var(--uic-header-menu-text-color-active);
    }

    .uic-header-menu-item__item {
        box-sizing: border-box;
        position: relative;
        padding: 0 20px 0 14px;
        min-width: 64px;
        height: var(--uic-header-height);
        display: flex;
        flex: 0 0 auto;
        align-items: center;
        justify-content: center;
        color: inherit;
        text-decoration: none;

        &:hover {
            background-color: var(--uic-header-menu-bg-color-hover);
        }

        .uic-header-menu--vertical &,
        .uic-header-menu-item__submenu & {
            flex: 1 0 auto;
            justify-content: stretch;
        }
    }

    .uic-header-menu-item__submenu {
        display: none;
        position: absolute;
        left: 0;
        top: 100%;
        width: 240px;
        background-color: var(--uic-header-bg-color-secondary);

        &--expanded {
            display: block;
        }

        &--vertical {
            left: 100%;
            top: 0;
        }
    }
}

.uic-header-menu-item--icon-only {
    .uic-header-menu-item__item {
        padding: 0 14px;
    }

    .uic-header-menu-item__label {
        display: none;
    }
}
